module.exports = __webpack_public_path__ + "img/our2.5d76bb87.svg";